// extracted by mini-css-extract-plugin
export default {"container":"ListOfSpecialCampaigns_container__suRga"};